import Splide from '@splidejs/splide';

// Import our default css theme for splide
import '@splidejs/splide/css';

document.addEventListener( 'DOMContentLoaded', () => {

  // Splide
  const splides = document.querySelectorAll('.splide')

  if(!!splides && splides.length > 0){
    splides.forEach(splide => {
      
      // Grab the slide interval and convert it to an integer and milliseconds
      const interval = parseInt(splide.dataset.interval) * 1000 || 3000
      const slides = parseInt(splide.dataset.slides) || 1
      const slidesMove = parseInt(splide.dataset.slidesMove) || 1
      const pagination = splide.dataset.pagination || false
      const arrowStyle = splide.dataset.arrowstyle || 'default'

      var splideObj = new Splide(splide, {
        type: 'slide', 
        autoplay: false, 
        perPage: slides, 
        pauseOnHover: false, 
        interval: interval,
        pagination: pagination,
        perMove: slidesMove,
        breakpoints: {
          748: {
            perPage: 1,
            perMove: 1
          }
        },
      });
      splideObj.on( 'mounted', function () {
        console.log('arrowStyle', arrowStyle)
        if (arrowStyle!=='circle') {
          renderArrows(splide)
        }
      } );
      splideObj.mount()
    })

    if (arrowStyle!=='circle') {
      addEventListener("resize", (event) => {
        var w = window.innerWidth;
        if (w<769) {
          splides.forEach(splide => {
            if (splide.querySelector('.splide__heading .splide__arrows')) {
              renderArrows(splide)
            }
          })
        }
        else {
          splides.forEach(splide => {
            if (splide.querySelector('.splide__heading .splide__arrows')==null) {
                renderArrows(splide)
            }
          })
        }

      });
    }

    function renderArrows(splide) {
      const arrows = splide.querySelector('.splide__arrows')
      const headingContainer = splide.querySelector('.splide__heading')
      const track = splide.querySelector('.splide__track');
      if (arrows && headingContainer && window.innerWidth > 769) {
        headingContainer.appendChild(arrows);
      }
      else {
        track.parentNode.insertBefore(arrows, track.nextSibling);
      }
    }

  }
})